import { useEffect } from "react"

export default function useSyncRefValue(ref, value) {
    useEffect(() => {
        ref.current = value
    }, [value])
}
